import Config from '../core/config';
import {makeRequest} from "../utils/httpRequest";

const apiUrl = Config.apiUrl;

export const getUserPermissions = async () => {
    const url = `${apiUrl}/api/users/permissions`;

    const response = await makeRequest(url, 'GET');

    return response?.permissions || [];
};


export const getCompanyPermissions = async () => {
    const url = `${apiUrl}/api/companies/permissions`;

    const response = await makeRequest(url, 'GET');

    return response?.permissions || [];
};
